import { useState, useEffect } from "react"

const STORAGE_PREFIX = "release-announcement-seen:"

/**
 * Per-release "show until dismissed" state. Seen-state is per-browser
 * (localStorage), the same trade-off as the Pine59 welcome announcement, but
 * keyed by release id so one dismissal never hides the next release.
 */
export function useReleaseAnnouncement(
  id: string | undefined,
  // Last day shown, YYYY-MM-DD (inclusive).
  until: string | undefined,
) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!id || !until || new Date().toISOString().slice(0, 10) > until) {
      setVisible(false)
      return
    }
    try {
      setVisible(!localStorage.getItem(STORAGE_PREFIX + id))
    } catch {
      setVisible(true)
    }
  }, [id, until])

  const dismiss = () => {
    setVisible(false)
    if (!id) return
    try {
      localStorage.setItem(STORAGE_PREFIX + id, new Date().toISOString())
    } catch {
      // Storage blocked (private mode, disabled site data): the bar stays
      // closed for this visit and comes back on the next one.
    }
  }

  return { visible, dismiss }
}
